var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIco3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.995,
    height: 81.28,
    viewBox: "0 0 89.995 81.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "analytics_sq-01-square",
    transform: "translate(0.46 -10.08)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 32.274,
    cy: 32.274,
    r: 32.274,
    transform: "translate(12.157 14.654)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 21.032,
    y2: 21.032,
    transform: "translate(67.294 69.798)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y1: 20.017,
    x2: 20.009,
    transform: "translate(68.598 11.06)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    y1: 18.987,
    x2: 18.987,
    transform: "translate(0.07 64.047)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80236",
    "data-name": "Path 80236",
    d: "M117.968,16.018V10.83H112.78",
    transform: "translate(-29.182)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    y1: 1.312,
    x2: 1.312,
    transform: "translate(19.19 62.602)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y1: 16.111,
    x2: 16.111,
    transform: "translate(22.088 44.905)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "5.04 3.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80237",
    "data-name": "Path 80237",
    d: "M52.59,55.282,53.9,53.97l1.3,1.312",
    transform: "translate(-13.598 -11.17)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 3.342,
    y2: 3.342,
    transform: "translate(43.157 45.661)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "4.91 2.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80238",
    "data-name": "Path 80238",
    d: "M63.77,63.38l1.3,1.312,1.312-1.312",
    transform: "translate(-16.493 -13.606)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y1: 16.082,
    x2: 16.074,
    transform: "translate(51.479 32.114)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "5.03 3.02"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    y1: 1.312,
    x2: 1.304,
    transform: "translate(68.346 30.017)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 3.705,
    height: 3.705,
    transform: "translate(48.56 53.674) rotate(-135)",
    fill: "#fff",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 3.705,
    height: 3.705,
    transform: "translate(40.299 45.42) rotate(-135)",
    fill: "#fff",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 3.705,
    height: 3.705,
    transform: "translate(68.961 30.684) rotate(-90)",
    fill: "#fff",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 3.705,
    height: 3.705,
    transform: "translate(16.226 66.886) rotate(-90)",
    fill: "#fff",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80239",
    "data-name": "Path 80239",
    d: "M64.386,44.728V64H45.118V44.728H64.386m5.188-5.188H39.93V69.183H69.573Z",
    transform: "translate(-10.32 -7.433)",
    fill: "#12784a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco3);
export default __webpack_public_path__ + "static/media/ico3.abb859317616b99a59cf58c20590531a.svg";
export { ForwardRef as ReactComponent };